const interfacePhrases = {
    rate_limited: '요청 빈도 제한',
    limit_exceeded: '한도 초과',
    used: '사용',
    identifier: '식별자',
    verification: '검증',
    messages: '메시지',
    data: '데이터',
    custom: '사용자 지정',
    management_api: '{{product}} 관리 API',
    management_api_role_description: '이 기본 역할은 관리 API에 대한 액세스를 허용합니다.',
    client_credentials: '클라이언트 자격 증명',
    authentication_request: '인증 요청',
    callback: '인증 콜백',
    help_title: 'iden 도움말 센터',
    help_subtitle: '작업 공간을 떠나지 않고 도움말 보기',
    open_help: '전체 도움말 페이지 열기',
    close_help: '도움말 닫기',
    about: '제품 정보 및 오픈 소스',
    open_navigation: '탐색 메뉴 열기',
    close_navigation: '탐색 메뉴 닫기',
    development_enabled: '개발 기능 활성화됨',
    beta: '베타',
    impersonation: '사용자 가장',
    key: '키',
    value: '값',
    error: '오류',
    details: '기술 세부 정보',
    callback_failed: '로그인 콜백을 완료할 수 없습니다.',
    back_sign_in: '로그인으로 돌아가기',
    powered_by: '제공',
    avatar: '아바타',
    logo: '로고',
    qr_code: 'QR 코드',
    sample_title: '예제를 보고 싶으신가요?',
    sample_description: '이 가이드를 사용하는 예제 애플리케이션을 살펴보세요.',
    sample_action: '예제 보기',
    further_readings: '추가 자료',
    complete_guide: '전체 가이드',
    custom_domains_notice: '<a>사용자 지정 도메인</a>을 추가하면 다음 엔드포인트를 사용할 수 있습니다: <code>{{endpoint}}</code>.',
    my_project: '내 프로젝트',
    my_secret: '내 비밀 키',
    my_token: '내 토큰',
    role_example: '조회자',
    reset_retry: '설정 초기화 후 다시 시도',
    open_dev_panel: '개발자 패널 열기',
    close_dev_panel: '개발자 패널 닫기',
    configuration: '설정',
    app_id: '애플리케이션 ID',
    extra_parameters: '추가 로그인 매개변수',
    prompt: '인증 프롬프트',
    scope: '범위',
    resource: '리소스',
    resources_space_delimited: '리소스(공백으로 구분)',
    sign_out_to_apply: '변경 사항을 적용하려면 로그아웃하세요.',
    refresh_token_grant: '새로 고침 토큰 권한 부여',
    organization_id: '조직 ID',
    console_result: '결과는 브라우저 콘솔에서 확인하세요.',
    request_token: '토큰 요청',
    user_info: '사용자 정보',
    get_id_token_claims: 'ID 토큰 클레임 가져오기',
    fetch_user_info: '사용자 정보 가져오기',
    device_initializing: '장치 인증 초기화 중…',
    device_success: '데모 애플리케이션에 로그인했습니다.',
    sign_in_information: '로그인 정보:',
    email: '이메일',
    username: '사용자 이름',
    user_id: '사용자 ID',
    sign_out_demo: '데모에서 로그아웃',
    device_expired: '장치 코드 만료',
    generic_error: '오류가 발생했습니다',
    device_expired_description: '장치 코드가 만료되었습니다. 다시 시도하여 새 코드를 받으세요.',
    sign_in_title: '계정에 로그인',
    scan_instruction: 'QR 코드를 스캔하거나 다른 장치에서 다음 주소를 여세요:',
    one_time_code: '일회용 코드 입력',
    token_info: '토큰 정보',
    get_access_token: '액세스 토큰 가져오기',
    context_unavailable: '계정 정보를 불러올 수 없습니다.',
    not_initialized: '계정 정보가 초기화되지 않았습니다.',
    not_set: '설정되지 않음',
    configured: '설정됨',
    password: '비밀번호',
    phone: '전화번호',
    search_help: '도움말 검색',
    language: '언어',
    menu: '메뉴',
    compatibility_notice: '호환성 안내: Logto에서 계승한 SDK, 패키지, 프로토콜, 구성 요소 및 요청 헤더 이름은 변경되지 않습니다.',
    source: '출처',
    upstream_repository: '원본 저장소',
    current_fork: '현재 저장소',
    license_notice: 'iden은 Mozilla Public License 2.0에 따라 라이선스가 부여된 오픈 소스 소프트웨어 Logto를 기반으로 합니다.',
    about_description: '제품 정보 및 오픈 소스 고지.',
    page_not_found: '페이지를 찾을 수 없음',
    page_not_found_description: '이 페이지를 사용할 수 없습니다. 도움말 센터로 돌아가세요.',
    introduction: '소개',
    quick_starts: '빠른 시작',
    integration: '통합',
    end_user_flows: '최종 사용자 흐름',
    authorization: '권한 부여',
    user_management: '사용자 관리',
    security: '보안',
    customization: '사용자 지정',
    connectors: '커넥터',
    organizations: '조직',
    self_hosting: '자체 호스팅',
    continue: '계속',
    loading: '불러오는 중…',
    save: '저장',
    saved: '저장됨',
    try_again: '다시 시도',
    client_id: '클라이언트 ID',
    client_secret: '클라이언트 비밀 키',
    redirect_uri: '리디렉션 URI',
    status: '상태',
    type: '유형',
    permissions: '권한',
    token_data: '토큰 데이터',
    context_data: '컨텍스트 데이터',
    jwt_extra_claims: '추가 토큰 클레임',
    action_result: '작업 결과',
    social_account_already_linked: '이 소셜 계정은 이미 연결되어 있습니다.',
};
export default Object.freeze(interfacePhrases);
